module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"nameSaved":"Name was saved","errors":{"name":{"required":"Name is required","string":"Please use only letters and numbers","min":"Name must be at least 3 letters"}}}}')
  delete Component.options._Ctor
}
